var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-wrapper"},[_c('table',{staticClass:"table",class:_vm.modifyClasses},[_c('thead',{staticClass:"table__header"},[_vm._t("thead")],2),_c('tbody',{staticClass:"table__body"},[_vm._t("tbody")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }